import { render, staticRenderFns } from "./deliveryUnitDistribution.vue?vue&type=template&id=4b4ddfcb&scoped=true&"
import script from "./deliveryUnitDistribution.vue?vue&type=script&lang=js&"
export * from "./deliveryUnitDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ddfcb",
  null
  
)

export default component.exports